var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "rgb(88, 106, 218)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16 4h-16v-.75c0-.69035594.44771525-1.25 1-1.25h14c.5522847 0 1 .55964406 1 1.25zm0 2.5v6.5c0 .5522847-.4477153 1-1 1h-14c-.55228475 0-1-.4477153-1-1v-6.5zm-12 3.5c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1h1c.55228475 0 1-.4477153 1-1s-.44771525-1-1-1z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCard);
export default __webpack_public_path__ + "static/media/icon-card.18fe25c1ca5589d7e508ea699b870185.svg";
export { ForwardRef as ReactComponent };